import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import useGetContacts from 'v2/hooks/useGetContacts';
import { Contact, DataVendor, GenericObject, User } from 'v2/models';
import Item from 'v2/pages/DataVendorDetails/ContactTab/Item';
import CreateContactModal from 'v2/common/ContactModals/CreateContactModal/CreateContactModal';
import AssociationTabList from 'v2/common/DRM/AssociationTab/AssociationTabList';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface StateProps {
  user: User;
}

interface ContactTabOwnProps {
  dataVendor: DataVendor;
}

type ContactTabProps = ContactTabOwnProps & StateProps;

const ContactTab = ({ dataVendor, user }: ContactTabProps) => {
  const { t } = useTranslation();
  const [showCreateContactModal, setShowCreateContactModal] = useState(false);
  const { data, refetch } = useGetContacts(
    { data_vendor: dataVendor.id },
    {},
    0
  );

  const companyContacts = useMemo<Contact[]>(
    () =>
      data?.results.filter((contact) => contact?.internal_designation) || [],
    [data]
  );

  const externalContacts = useMemo<Contact[]>(
    () =>
      data?.results.filter((contact) => !contact?.internal_designation) || [],
    [data]
  );

  if (!data) {
    return null;
  }

  const handleCloseModal = () => {
    setShowCreateContactModal(false);
    refetch();
  };

  return (
    <AssociationTabList
      groups={[
        {
          name: dataVendor.name,
          items: externalContacts.map((contact) => (
            <Item
              key={contact.id}
              contact={contact}
              backLinkTitle={dataVendor.name}
            />
          )),
        },
        {
          name: user.master_organization_name || 'Your Organization',
          items: companyContacts.map((contact) => (
            <Item
              key={contact.id}
              contact={contact}
              backLinkTitle={dataVendor.name}
            />
          )),
        },
      ].filter((group) => group.items.length > 0)}
      buttonLabel={`Add ${t(TranslationKeys.contact_one, {
        postProcess: PostProcessKeys.TitleCase,
      })}`}
      onButtonClick={() => setShowCreateContactModal(true)}
    >
      <CreateContactModal
        dataVendor={dataVendor}
        show={showCreateContactModal}
        onClose={handleCloseModal}
      />
    </AssociationTabList>
  );
};

const mapStateToProps = (state: GenericObject) => {
  return {
    user: state.user.user,
  };
};

export default connect<StateProps>(mapStateToProps)(ContactTab);
